import { Pipe, PipeTransform } from '@angular/core';
import { SharedService } from '../../../services/shared/shared.service';

@Pipe({
  name: 'modifyPhoneNumber',
  standalone: false,
})
export class ModifyPhoneNumberPipe implements PipeTransform {
  constructor(private _sharedService: SharedService) {}

  transform(value: string, ...args: unknown[]): unknown {
    let number = JSON.parse(JSON.stringify(value)); // deep copy
    number = this._sharedService.insertStrAtPos(number, '-', 3);
    number = this._sharedService.insertStrAtPos(number, '-', 7);
    return number;
  }
}
